import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast, getErrorStatus } from "../../toast";

export const job_set_cancelled: Action<Ctx, { id?: string }> = async (
  { sb },
  data,
  params,
) => {
  const job_opening_id = data.id ?? params.get("id");
  if (!job_opening_id) {
    return { ok: false, error: "Missing id on row record or in URL" };
  }

  // Goes through the cancel endpoint (not a direct status update) so the active
  // claim is cancelled and the claiming substitute is notified.
  const { error } = await sb.functions.invoke(
    `api/jobs/${job_opening_id}/cancel`,
    { method: "POST" },
  );
  if (error) {
    const status = getErrorStatus(error);
    if (status === 409) {
      toast({ variant: "warning", text: "Job is already cancelled." });
    } else if (status === 404) {
      toast({ variant: "warning", text: "Job not found." });
    } else if (status === 403) {
      toast({
        variant: "error",
        text: "You're not authorized to cancel this job.",
      });
    } else {
      toast({ variant: "error", text: "Cancel failed. Try again" });
    }
    return { ok: false, error: error.message };
  }
  invalidate("jobs");
  toast({ variant: "success", text: "Job cancelled." });
  return { ok: true };
};
